




























































































































































































import { Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import {
  CREATE_MAP,
  FILE_ACTIVATE,
  FILE_PURPOSE,
  getPageCount,
  routerPushSafer,
  viewPageToQueryPage
} from '@/constants';
import FileGeodeticService from '@/entities/file-geodetic/file-geodetic.service';
import FileCard from '@/custom/page/filemanager/file/FileCard.vue';
import { format } from 'date-fns';
import ProjectService from '@/entities/project/project.service';
import { IProject } from '@/shared/model/project.model';
import Map2dService from '@/entities/map-2-d/map-2-d.service';
import Vr360Service from '@/entities/vr-360/vr-360.service';
import ConfirmDialog from '@/custom/page/common/ConfirmDialog.vue';
import Model3dService from '@/entities/model-3-d/model-3-d.service';
import { IMap2d } from '@/shared/model/map-2-d.model';
import { IVr360 } from '@/shared/model/vr-360.model';
import { IModel3d } from '@/shared/model/model-3-d.model';
import { IFileGeodetic } from '@/shared/model/file-geodetic.model';
import PreviewFileDialog from '@/custom/page/common/PreviewFileDialog.vue';

@Component({ components: { PreviewFileDialog, ConfirmDialog, FileCard } })
export default class ProjectFilesDetail extends Vue {
  projectId: number;
  project: IProject = { id: parseInt(this.$route.params.projectId) };
  files = [];
  filePurposeFilter: string;

  addAllSelect(arr = []) {
    return [{ id: '', name: 'Tất cả' }, ...arr];
  }

  filePurposeForSelect = {
    list: this.addAllSelect(FILE_PURPOSE)
  };

  fileActivateForSelect = {
    list: this.addAllSelect(FILE_ACTIVATE)
  };

  map2ds = [];
  vr360s = [];
  model3ds = [];

  map2dMap = {};
  vr360Map = {};
  model3dMap = {};

  filePage = {
    page: 1,
    size: 10,
    total: 10
  };
  map2dPage = {
    page: 1,
    size: 10,
    total: 10
  };
  vr360Page = {
    page: 1,
    size: 10,
    total: 10
  };
  model3dPage = {
    page: 1,
    size: 10,
    total: 10
  };
  @Prop() fileListOpen;

  get fileMap() {
    return CREATE_MAP(this.files);
  }

  @Provide() refreshPage = () => {
    this.fetchData();
  };

  filesSplitByTypeConstant = [
    { code: 'IMG', name: 'Hình ảnh', dataFilter: e => e.filePurpose === 'IMG' },
    { code: 'VIDEO', name: 'Video', dataFilter: e => e.filePurpose === 'VIDEO' },
    { code: 'GEODETIC', name: 'Bản đồ', dataFilter: e => e.filePurpose === 'GEODETIC' },
    { code: 'OTHER', name: 'Khác', dataFilter: e => e.filePurpose === 'OTHER' }
  ];

  selectFiles = [];

  onSelectFilePurposeChange() {
    this.fetchData();
  }

  onSelectFileActivateChange() {
    this.fetchData();
  }

  onFileSelectChange(val, id) {
    this.files[id].select = val;
    this.selectFiles = this.files.filter(e => e.select);
  }

  selectMap2ds = [];

  onMap2dSelectChange(val, id) {
    this.map2ds[id].select = val;
    this.selectMap2ds = this.map2ds.filter(e => e.select);
  }

  selectVr360s = [];

  onVr360SelectChange(val, id) {
    this.vr360s[id].select = val;
    this.selectVr360s = this.vr360s.filter(e => e.select);
  }

  selectModel3ds = [];

  onModel3dSelectChange(val, id) {
    this.model3ds[id].select = val;
    this.selectModel3ds = this.model3ds.filter(e => e.select);
  }

  mounted() {
    this.showAllFiles = '';
    this.projectId = parseInt(this.$route.params.projectId);
    const projectService = new ProjectService();
    projectService.find(this.projectId).then(rs => {
      this.project = rs;
      this.fetchData();
    });
  }

  async fetchData() {
    await Promise.all([this.fetchMap2d(), this.fetchVr360(), this.fetchModel3d()]);
    await this.fetchFiles();
  }

  showAllFiles = '';

  @Watch('filePage.page')
  @Watch('filePage.size')
  @Watch('showAllFiles')
  async fetchFiles() {
    const fileGeodeticService = new FileGeodeticService();
    let rs: any;
    if (this.showAllFiles === '') {
      rs = await fileGeodeticService.filterGet(
        this.viewPageToQueryPage(this.filePage),
        encodeURI(
          JSON.stringify({
            'project.id': this.project.id,
            filePurpose: this.filePurposeFilter
          })
        )
      );
    } else {
      rs = await fileGeodeticService.filterGet(
        this.viewPageToQueryPage(this.filePage),
        encodeURI(
          JSON.stringify({
            'project.id': this.project.id,
            activated: this.showAllFiles,
            filePurpose: this.filePurposeFilter
          })
        )
      );
    }

    this.files = [...rs.data];
    this.filePage.total = parseInt(rs.headers['x-total-count']);
  }

  @Watch('map2dPage.page')
  @Watch('map2dPage.size')
  async fetchMap2d() {
    let map2dService = new Map2dService();
    let rs = await map2dService.filter(this.viewPageToQueryPage(this.map2dPage), { projectId: this.project.id });

    this.map2ds = [...rs.data];
    this.map2ds.forEach(e => (e.select = false));
    this.map2dPage.total = parseInt(rs.headers['x-total-count']);
    this.map2dMap = CREATE_MAP(this.map2ds);
  }

  @Watch('vr360Page.page')
  @Watch('vr360Page.size')
  async fetchVr360() {
    let vr360Service = new Vr360Service();
    let rs = await vr360Service.filter(this.viewPageToQueryPage(this.vr360Page), { projectId: this.project.id });

    this.vr360s = [...rs.data];
    this.vr360s.forEach(e => (e.select = false));
    this.vr360Page.total = parseInt(rs.headers['x-total-count']);
    this.vr360Map = CREATE_MAP(this.vr360s);
  }

  @Watch('model3dPage.page')
  @Watch('model3dPage.size')
  async fetchModel3d() {
    let model3dService = new Model3dService();
    model3dService.filter(this.viewPageToQueryPage(this.model3dPage), { projectId: this.project.id }).then(rs => {
      this.model3ds = [...rs.data];
      this.model3ds.forEach(e => (e.select = false));
      this.model3dPage.total = parseInt(rs.headers['x-total-count']);
      this.model3dMap = CREATE_MAP(this.model3ds);
    });
  }

  viewPageToQueryPage(page) {
    return viewPageToQueryPage(page);
  }

  getPageCount(page) {
    return getPageCount(page) || 1;
  }

  onSelectChange(id, val) {
    this.files[id].select = val;
  }

  getImgThumbnailUrl(item) {
    const fileGeodeticService = new FileGeodeticService();
    return fileGeodeticService.thumbnail(item.id);
  }

  dialogImagePreview = {
    open: false,
    title: '',
    fileGeodetic: null
  };

  openPreviewDialog(item: IFileGeodetic) {
    if (item.map2d) {
      this.$router.push(`/map2d/${item.map2d.id}`);
    } else if (item.model3d) {
      this.$router.push(`/model3d/${item.model3d.id}`);
    } else if (item.vr360) {
      this.$router.push(`/vr360/${item.vr360.id}`);
    } else if (item.thumbnailFilePath) {
      this.dialogImagePreview = { open: false, fileGeodetic: null, title: '' };
      this.dialogImagePreview.title = `${this.formatDate(item.flightDate) || item.fileName}`;
      this.dialogImagePreview.fileGeodetic = item;
      this.dialogImagePreview.open = true;
    }
    // console.log(this.dialogImagePreview);
  }

  formatDate(date) {
    if (!date) return null;
    const d = new Date(date);
    return format(d, 'dd/MM/yyyy');
  }

  formatDateTime(date) {
    const d = new Date(date);
    return format(d, 'dd/MM/yyyy HH:mm:ss');
  }

  cfd = {
    title: '',
    text: '',
    okOk: () => undefined,
    open: false
  };

  deleteFile() {
    this.deleteFileOrMapView(this.selectFiles, 'files', async () => {
      let fileGeodeticService = new FileGeodeticService();
      await Promise.all(this.selectFiles.map(e => fileGeodeticService.delete(e.id)));
    });
  }

  deleteMap2d() {
    this.deleteFileOrMapView(this.selectMap2ds, 'bản đồ 2D', async () => {
      let map2dService = new Map2dService();
      await Promise.all(this.selectMap2ds.map(e => map2dService.delete(e.id)));
    });
  }

  deleteVr360() {
    this.deleteFileOrMapView(this.selectVr360s, 'vr360', async () => {
      let vr360Service = new Vr360Service();
      await Promise.all(this.selectVr360s.map(e => vr360Service.delete(e.id)));
    });
  }

  deleteModel3d() {
    this.deleteFileOrMapView(this.selectModel3ds, 'model3d', async () => {
      let model3dService = new Model3dService();
      await Promise.all(this.selectModel3ds.map(e => model3dService.delete(e.id)));
    });
  }

  deleteFileOrMapView(list, name, cb) {
    if (!list || list.length === 0) {
      return;
    }
    this.actionDialog(`Bạn muốn xóa ${list.length} ${name}?`, () => `Xóa thành công ${list.length} ${name}`, cb);
  }

  actionDialog(confirmMessage, successTitleFn, cb) {
    this.cfd = {
      title: 'Xác nhận',
      text: confirmMessage,
      open: true,
      okOk: async () => {
        try {
          let rs = await cb();
          (this.$root as any).$bvToast.toast(successTitleFn(rs), {
            toaster: 'b-toaster-top-center',
            title: 'Success',
            variant: 'success',
            solid: true,
            autoHideDelay: 5000
          });
          this.removeSelect();
          await this.fetchData();
        } catch (e) {
          (this.$root as any).$bvToast.toast(`Đã có lỗi xảy ra: ${e}`, {
            toaster: 'b-toaster-top-center',
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          });
        }
      }
    };
  }

  private removeSelect() {
    this.selectMap2ds = [];
    this.selectVr360s = [];
    this.selectModel3ds = [];
  }

  onModeChange() {
    if (this.fileListOpen) {
      routerPushSafer(this.$router, `/file-manager-page/file-project/${this.projectId}/map-view`);
    } else {
      routerPushSafer(this.$router, `/file-manager-page/file-project/${this.projectId}/files`);
    }
  }

  fileSelectAll = false;

  selectAll() {
    if (!this.fileSelectAll) {
      this.files.forEach(file => (file.select = true));
      this.selectFiles = [...this.files];
    } else {
      this.files.forEach(file => (file.select = false));
      this.selectFiles = [];
    }
    this.fileSelectAll = !this.fileSelectAll;
  }

  joinMap2dLoading = false;

  async joinMap2ds() {
    let map2dService = new Map2dService();
    this.joinMap2dLoading = true;
    try {
      this.actionDialog(
        `Bạn có chắc chắn muốn ghép ${this.selectMap2ds.length} bản đồ 2D đã chọn thành 1?`,
        rs => `Ghép thành công map 2d, id=${rs.id}`,
        async () => {
          return await map2dService.join(this.selectMap2ds.map(e => e.id));
        }
      );
    } finally {
      this.joinMap2dLoading = false;
    }
  }

  fileFlightDateCard(file: IFileGeodetic) {
    if (file.map2d) {
      return this.geodeticFlightDate(this.map2dMap[file.map2d.id], file);
    } else if (file.model3d) {
      return this.geodeticFlightDate(this.model3dMap[file.model3d.id], file);
    } else if (file.vr360) {
      return this.geodeticFlightDate(this.vr360Map[file.vr360.id], file);
    }
    return file.flightDate || null;
  }

  geodeticFlightDate(item: IMap2d | IVr360 | IModel3d, file) {
    if (item && item.flightDate) {
      return new Date(item.flightDate);
    }
    return file.flightDate || null;
  }

  fileGeodeticCardName(file: IFileGeodetic) {
    if (file.flightDate) {
      return format(new Date(file.flightDate), 'dd/MM/yyyy') + '';
    }
    if (file.map2d) {
      return this.geodeticCardName(this.map2dMap[file.map2d.id], file);
    } else if (file.model3d) {
      return this.geodeticCardName(this.model3dMap[file.model3d.id], file);
    } else if (file.vr360) {
      return this.geodeticCardName(this.vr360Map[file.vr360.id], file);
    }
    return file.fileName || (this.fileMap[(file || {}).id] || {}).fileName || '';
  }

  geodeticCardName(item: IMap2d | IVr360 | IModel3d, file) {
    if (item && item.flightDate) {
      return format(new Date(item.flightDate), 'dd/MM/yyyy') + '';
    }
    return file.fileName || (this.fileMap[(file || {}).id] || {}).fileName || '';
  }

  onFileUpdate(fileId) {
  }

  get hasAdminRole() {
    let account = this.$store.getters.account;
    return account.authorities.includes('ROLE_ADMIN');
  }
}
